"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGInputFocusIndicatorBase = exports.ValidFocusIndicator = exports.ErrorFocusIndicator = exports.InvertFocusIndicator = exports.DefaultFocusIndicator = exports.PreFocusIndicator = exports.ValidGreen = exports.ErrorRed = exports.FocusBlue = void 0;
var tslib_1 = require("tslib");
var TypeStyle = require("typestyle");
/** @private */
exports.FocusBlue = '#3498DB';
/** @private */
exports.ErrorRed = '#C93A47';
/** @private */
exports.ValidGreen = '#008057';
/** @private */
exports.PreFocusIndicator = Object.freeze({
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 1,
});
var FocusIndicator = function (color) {
    if (color === void 0) { color = exports.FocusBlue; }
    return Object.freeze({
        borderColor: color,
        boxShadow: "0 0 4px 0 " + color,
        outline: 'none',
        $nest: {
            '&::-moz-focus-inner': { $unique: true, border: 'none' }
        }
    });
};
/** @private */
exports.DefaultFocusIndicator = FocusIndicator();
/** @private */
exports.InvertFocusIndicator = FocusIndicator('white');
/** @private */
exports.ErrorFocusIndicator = FocusIndicator(exports.ErrorRed);
/** @private */
exports.ValidFocusIndicator = FocusIndicator(exports.ValidGreen);
/**
 * SVG doesn't support `box-shadow`; using pseudo element instead to get correct style
 * @private
 */
exports.SVGInputFocusIndicatorBase = TypeStyle.style({
    position: 'relative',
    $nest: {
        '&.focus::after': tslib_1.__assign(tslib_1.__assign({ border: '1px solid transparent' }, exports.DefaultFocusIndicator), { content: "\"\"", position: 'absolute', pointerEvents: 'none', top: 1, right: 1, bottom: 1, left: 1 })
    }
});
//# sourceMappingURL=FocusIndicators.js.map